
export const setAppTitle = ( string ) => {
  console.log('set app title')
  return{
    type: 'SET_APP_TITLE',
    payload: string
  }
}